var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getConfig } from "@jti/fe-common";
import { magento } from "@jti/magento";
import { getUser, LoyaltyApi } from "@jti/rest-api";
import { fetchCartPrices } from "./cartSlice/actions/fetchCartPrices";
export const fetchLoyaltyStatus = createAsyncThunk("loyalty/status", (_, { dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    const config = getConfig();
    const user = getUser();
    const loyaltyApi = LoyaltyApi.init();
    if (config.IS_LOYALTY_ENABLED !== "true") {
        return {
            status: false,
            points: 0,
            pending_points: 0,
            vouchers: [],
        };
    }
    const status = yield loyaltyApi.getStatus();
    if (status && (user === null || user === void 0 ? void 0 : user.uuid) && (user === null || user === void 0 ? void 0 : user.ciam_token)) {
        dispatch(fetchLoyaltyPoints());
    }
    return {
        status,
    };
}));
export const fetchLoyaltyVouchers = createAsyncThunk("loyalty/vouchers", (data) => __awaiter(void 0, void 0, void 0, function* () {
    const loyaltyApi = LoyaltyApi.init();
    const user = getUser();
    if ((user === null || user === void 0 ? void 0 : user.uuid) && (user === null || user === void 0 ? void 0 : user.ciam_token)) {
        const vouchers = (yield loyaltyApi.getEligibleCampaigns(user.uuid, user.ciam_token, data)) || [];
        return { vouchers };
    }
    return { vouchers: [] };
}));
const fetchLoyaltyPoints = createAsyncThunk("loyalty/fetchLoyaltyPoints", (useLocalCache) => __awaiter(void 0, void 0, void 0, function* () {
    const user = getUser();
    const loyaltyApi = LoyaltyApi.init();
    let points = 0;
    let pending_points = 0;
    if ((user === null || user === void 0 ? void 0 : user.uuid) && (user === null || user === void 0 ? void 0 : user.ciam_token)) {
        const getPoints = yield loyaltyApi.getPoints(user.uuid || "", user.ciam_token, useLocalCache);
        points = (getPoints === null || getPoints === void 0 ? void 0 : getPoints.points) || 0;
        pending_points = (getPoints === null || getPoints === void 0 ? void 0 : getPoints.pending_points) || 0;
    }
    return { points, pending_points };
}));
export const applyCampaign = createAsyncThunk("loyalty/applyCampaign", ({ cartId, campaign_uuid }, { dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield magento.applyCampaignToCart(cartId, campaign_uuid);
        dispatch(loyalty.actions.setLoyaltyCampaignId(campaign_uuid));
        dispatch(fetchCartPrices(cartId));
        return response;
    }
    catch (error) {
        yield dispatch(fetchLoyaltyPoints(false));
        dispatch(loyalty.actions.setCampaignError(error.response.errors));
        yield dispatch(removeCampaign(cartId));
        dispatch(loyalty.actions.setCampaignError([]));
    }
}));
export const removeCampaign = createAsyncThunk("loyalty/removeCampaign", (cartId, { dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    yield magento.removeCampaignFromCart(cartId);
    dispatch(fetchCartPrices(cartId));
    dispatch(loyalty.actions.setLoyaltyCampaignId(""));
}));
export const initialLoyalty = {
    points: 0,
    pending_points: 0,
    status: false,
    loyaltyChoice: undefined,
    loyaltyCampaignId: "",
    isLoyaltyError: false,
    vouchers: [],
    isLoaded: false,
    campaignErrors: [],
};
export const loyalty = createSlice({
    name: "loyalty",
    initialState: initialLoyalty,
    reducers: {
        setLoyaltyChoice(state, action) {
            state.isLoyaltyError = false;
            state.loyaltyChoice = action.payload;
        },
        setLoyaltyCampaignId(state, action) {
            state.loyaltyCampaignId = action.payload;
        },
        setLoyaltyError(state, action) {
            state.isLoyaltyError = action.payload;
        },
        setCampaignError(state, action) {
            state.campaignErrors = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchLoyaltyStatus.fulfilled, (state, action) => {
            state.status = action.payload.status;
            state.isLoaded = true;
        });
        builder.addCase(fetchLoyaltyPoints.fulfilled, (state, action) => {
            state.points = action.payload.points;
            state.pending_points = action.payload.pending_points;
        });
        builder.addCase(fetchLoyaltyVouchers.fulfilled, (state, action) => {
            state.vouchers = action.payload.vouchers;
        });
    },
});
//# sourceMappingURL=loyalty.js.map